// API設定
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export { API_BASE_URL };